import React from 'react';
import BaseGrid from 'components/atoms/base-grid';

interface IProps {
  fields: { name: string; value: string }[];
}

const ConsentPatientInfo: React.FC<IProps> = ({ fields }) => {
  return (
    <BaseGrid columns={2} rowGap={5}>
      {fields.map((field) => (
        <p>
          {field.name}: {field.value}
        </p>
      ))}
    </BaseGrid>
  );
};

export default ConsentPatientInfo;
